import React, {useEffect} from "react";
import {useSearchParams} from "react-router-dom";

const Module: React.FC = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        window.location.assign(`https://mobile.eu-central-1.saucelabs.com/`);
    }, []);

    return <></>;
};

export default Module;